export default __webpack_public_path__ + "static/media/pokemon_psychic.4703e033.png";